import { render, staticRenderFns } from "./Trainers.vue?vue&type=template&id=2b7572b1&scoped=true&"
import script from "./Trainers.vue?vue&type=script&lang=js&"
export * from "./Trainers.vue?vue&type=script&lang=js&"
import style0 from "./Trainers.vue?vue&type=style&index=0&id=2b7572b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7572b1",
  null
  
)

export default component.exports